import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { RestartAlt, Save } from '@mui/icons-material';
import { Alert, Button, ButtonGroup, Stack } from '@mui/material';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { ConsumerDao } from '../../../data/ConsumerDAO';
import { useSingleClickEditing } from '../../../hooks/DataGrid';
import { useLocalObject } from '../../../hooks/useLocalObject';
const isLatLngValid = (num) => {
    return num !== undefined && num !== null && !isNaN(parseFloat(`${num}`));
};
export const AreaPointsTab = ({ contextArea, userFunctions, viewOnly }) => {
    const [localArea, setLocalArea, resetLocalArea, hasEdits] = useLocalObject({ primary: contextArea });
    const dataGridApiRef = useGridApiRef();
    /** Returns true if the row has been updated */
    const updatePointFromRow = (row) => {
        const pointsCopy = [...localArea.points];
        const pointCopy = pointsCopy[row.pointIndex];
        pointCopy.lat = parseFloat(row.lat);
        pointCopy.lng = parseFloat(row.lng);
        setLocalArea((o) => ({ ...o, points: pointsCopy }));
        const hasBeenEdited = pointCopy.lat !== contextArea.points[row.pointIndex].lat || pointCopy.lng !== contextArea.points[row.pointIndex].lng;
        return hasBeenEdited;
    };
    const saveArea = () => {
        const savePoints = [...localArea.points];
        savePoints[savePoints.length - 1] = structuredClone(savePoints[0]);
        const saveArea = { ...localArea, points: savePoints, lastPoint: savePoints[savePoints.length - 1] };
        ConsumerDao.save(saveArea).then((res) => {
            if (res.err) {
                console.error('saveArea', res.err);
            }
            else if (!res.data) {
                console.warn('saveArea', 'no data!');
            }
            else {
                userFunctions.addObjectsToState([saveArea]);
            }
        });
    };
    const singleClickEditing = useSingleClickEditing();
    return (_jsx(_Fragment, { children: _jsx(Stack, { gap: 1, children: (localArea.points?.length ?? 0) === 0 ? (_jsxs(Alert, { severity: "info", children: [localArea.name, " does not have a map area, so there are no points to show."] })) : (_jsxs(_Fragment, { children: [viewOnly === false && (_jsx(Stack, { direction: "row", gap: 1, sx: { alignSelf: 'flex-end' }, children: _jsxs(ButtonGroup, { children: [_jsx(Button, { disabled: !hasEdits, onClick: resetLocalArea, variant: "contained", size: "small", startIcon: _jsx(RestartAlt, {}), children: "Reset" }), _jsx(Button, { disabled: !hasEdits, onClick: saveArea, variant: "contained", size: "small", startIcon: _jsx(Save, {}), children: "Save" })] }) })), _jsx(DataGrid, { apiRef: dataGridApiRef,
                        density: 'compact',
                        pageSizeOptions: [10],
                        disableRowSelectionOnClick: true,
                        hideFooterSelectedRowCount: true,
                        hideFooterPagination: localArea.points.length <= 10,
                        hideFooter: localArea.points.length <= 10,
                        initialState: { pagination: { paginationModel: { pageSize: 10 } } },
                        ...singleClickEditing,
                        processRowUpdate: (newRow, oldRow, info) => {
                            if (!isLatLngValid(newRow.lat) || !isLatLngValid(newRow.lng))
                                return oldRow;
                            const edited = updatePointFromRow(newRow);
                            // I think there's some kind of race condition ???? The rows seem to update and then the row update is applied. And the row update hasn't been edited?
                            return { ...newRow, edited };
                        },
                        columns: [
                            {
                                field: 'lat',
                                headerName: 'Latitude',
                                editable: viewOnly === false,
                                minWidth: 150,
                                valueFormatter: (v) => (typeof v === 'number' ? v.toFixed(6) : ''),
                            },
                            {
                                field: 'lng',
                                headerName: 'Longitude',
                                editable: viewOnly === false,
                                minWidth: 150,
                                valueFormatter: (v) => (typeof v === 'number' ? v.toFixed(6) : ''),
                            },
                            {
                                field: 'edited',
                                headerName: '',
                                valueFormatter: (v) => (v ? 'Edited' : ''),
                            },
                        ],
                        rows: localArea.points.slice(0, localArea.points.length === 1 ? localArea.points.length : localArea.points.length - 1).map((p, i) => {
                            return {
                                ...p,
                                id: `${localArea.sk}_point${i}`,
                                edited: p.lat !== contextArea.points[i].lat || p.lng !== contextArea.points[i].lng,
                                pointIndex: i,
                            };
                        }) })] })) }) }));
};
